import React from 'react';
import AdminLayout from './AdminLayout';

const Dashboard = () => {
    return (
        <AdminLayout>
            <div className='user_dashboard'>
                dashboard
            </div>
        </AdminLayout>
    );
}

export default Dashboard;
